import 'regenerator-runtime/runtime';
import '@onereach/actiondesk-widgets-dispatcher/dist/auto/style.css';
import '@onereach/styles';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import * as VueCompositionAPI from '@vue/composition-api';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { install, i18n, applyDefaultMessages } from '@onereach/actiondesk-widgets-dispatcher';

import DEFAULT_TRANSLATIONS from '@/i18n/locales/en.json';
import AppLauncher from './AppLauncher.vue';
import { APP_LAUNCHER_ROUTES } from './constants';

Vue.use(VueCompositionAPI.default);
Vue.use(VueRouter);

/* Vuex is a backwards compatibility feature */
Vue.use(Vuex);
Vue.use(PiniaVuePlugin);

/* Helpers are backwards compatibility feature from Action Desk */
Vue.prototype.$helpers = {};
Vue.prototype.$ORConfig = {};

Vue.config.devtools = HITL_ENABLE_VUE_DEVTOOLS;

/* UI Next warnings cannot be fixed in Vue 2, so we hide these warning.
Also, remove i18n warnings */
Vue.config.warnHandler = (message, vm, trace) => {
  const OR_UI_WARNING = 'invalid prop: type check';
  const I18N_WARNING = 'vue-i18n';
  const isUIWarning = message.toLowerCase().includes(OR_UI_WARNING);
  const isI18nWarning = message.toLowerCase().includes(I18N_WARNING);

  if (isUIWarning || isI18nWarning) {
    return;
  }

  console.warn('[Vue Warn]: '.concat(message, trace));
};

/* UI bundles use these dependencies as a global variables */
(window as any).Vue = Vue;
(window as any).VueCompositionAPI = VueCompositionAPI;

const main = async () => {
  /* Allow integration with Action Desk cards */
  await install(Vue);
  applyDefaultMessages(DEFAULT_TRANSLATIONS);

  /* TODO: Replace with "createApp" in Vue 2.7 or Vue 3 */
  new Vue({
    el: '#app',
    i18n,
    pinia: createPinia(),
    store: new Vuex.Store({}),
    router: new VueRouter({ mode: 'history', routes: APP_LAUNCHER_ROUTES }),
    components: { AppLauncher },
    render(h) {
      return h(AppLauncher);
    },
  });
};

main();
